module.exports = __webpack_public_path__ + "img/instruction_vieworder_2d.f72e9668.png";